import script from "./CalendarWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarWidget.vue?vue&type=script&setup=true&lang=js"

import "./CalendarWidget.vue?vue&type=style&index=0&id=897ba76c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-897ba76c"]])

export default __exports__